// extracted by mini-css-extract-plugin
module.exports = {"menu":"Footer_menu__Q8ry0","termsOfUse":"Footer_termsOfUse__gzmSw","logo":"Footer_logo__14cY9"};